import {envIsPublicCloud} from '../../config';

export const ORG_DASHBOARD = '/org/dashboard';
export const ORG_ROLES_NEW = envIsPublicCloud
  ? '/account-settings/:orgName/:tab/roles/new'
  : '/org/settings/roles/new';
export const ORG_ROLE_EDIT = envIsPublicCloud
  ? '/account-settings/:orgName/:tab/roles/:roleId/edit'
  : '/org/settings/roles/:roleId/edit';

export const ORG_PROXY = '/org/proxy';
export const ORG_TEAMS = '/org/teams';
export const ORG_USER_ACTIVITY = '/org/activity';
export const ORG_SERVICE_ACCOUNTS = '/org/service-accounts';
export const ORG_API_KEYS = '/org/api-keys';
export const ORG_BILLING = '/org/billing';
export const ORG_SETTINGS = envIsPublicCloud
  ? '/account-settings/:orgName/settings'
  : '/org/settings';

export const ORG_SETTINGS_PATHS = [ORG_SETTINGS, ORG_ROLES_NEW, ORG_ROLE_EDIT];
